<div class="wd-avatar wd-single-avatar" *ngIf="previewAvatar">
  <div>
    <div *ngIf="avatar === ''" [ngStyle]="{'width': avatarWidth+'px', 'height': avatarWidth+'px' }"
         class="wd-not-has-avatar">
      {{shortName}}
    </div>

    <div *ngIf="avatar !== ''" [ngStyle]="{'width': avatarWidth+'px', 'height': avatarWidth+'px' }"
         [style]="personalStyle" class="wd-has-avatar">
      <img title="{{fullName}}" src="{{'https://testfinanceplus.proventum.me'+avatar}}" alt="">
    </div>
  </div>
</div>
